const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { projectType: { $ne: '' } }, { objectType: 'object.object-type.living.options.wohn-und-geschaeftshaus' }]
}

export default conditions
